import { ColumnViewModel } from './column-types';

export function validateView(view: ColumnViewModel): void {
  view.defaultVisible.forEach(col => {
    if (!view.columns.includes(col)) {
      throw new Error(
        `Column '${col}' is visible by default but not declared in columns array`,
      );
    }
  });
}

export function createBaseColumns(columns: string[]): string[] {
  return [...columns];
}

export function mergeColumns(
  baseColumns: string[],
  specificColumns: string[],
  position: 'start' | 'end' = 'end'
): string[] {
  return position === 'start' 
    ? [...specificColumns, ...baseColumns]
    : [...baseColumns, ...specificColumns];
}